var _desc, _defs, _rect, _rect2, _path, _rect3, _path2, _rect4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeftSlim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u0421\\u0442\\u0440\\u0435\\u043B\\u043A\\u0430 \\u041D\\u0430\\u0437\\u0430\\u0434",
    width: 53,
    height: 54,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u0427\\u0430\\u0441\\u0442\\u044C \\u0441\\u0442\\u0440\\u0435\\u043B\\u043A\\u0438",
    width: 43,
    height: 0,
    transform: "translate(5.000000 27.000000) rotate(0.000008)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M5 27L48 27",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u0427\\u0430\\u0441\\u0442\\u044C \\u0441\\u0442\\u0440\\u0435\\u043B\\u043A\\u0438",
    width: 31,
    height: 0,
    transform: "translate(5.098633 26.936523) rotate(45.530388)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M5.09863 26.9365L26.8151 49.0586",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u0427\\u0430\\u0441\\u0442\\u044C \\u0441\\u0442\\u0440\\u0435\\u043B\\u043A\\u0438",
    width: 31,
    height: 0,
    transform: "translate(5.098633 27.063477) rotate(-45.530388)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M5.09863 27.0635L26.8151 4.94141",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSlim);
export default __webpack_public_path__ + "static/media/arrow-left-slim.aa85464f5446022e2edd6792232d4964.svg";
export { ForwardRef as ReactComponent };